import { render, staticRenderFns } from "./SubscriptionBox.vue?vue&type=template&id=82e0b63c&scoped=true&"
import script from "./SubscriptionBox.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionBox.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionBox.vue?vue&type=style&index=0&id=82e0b63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e0b63c",
  null
  
)

export default component.exports